//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'
import * as axios from "@/store/http";
import * as auth from "@/utils/auth";

// var list

  export default {
    name: "pcaside",
    components: { SidebarItem },
    data() {
      return {
        isCollapse: false,
        asideMenuData:[],
        showmenu:false
      };
    },
    created(){
      var devflag = process.env.NODE_ENV;
      var protocol = document.location.protocol;
      var domain = window.location.host;
      this.showmenu = true;
      let params ={
        "sysid" : process.env.SYS_NAME,
         path:(devflag === 'development')?process.env.API_LOGIN_ROOT:protocol+"//"+domain+"/"+process.env.API_LOGIN_ROOT,
      };
      
      axios.post("menu/getmenu",params,{
        }).then((res)=>{
          console.log('2019年12月05日15:06:28 aside.vue[动态菜单数据]——[res] :',res);
          this.asideMenuData=res.data.data.menuList
        }).catch(function(error){
          console.log(error)//错误处理 相当于error
        })
    },
    computed: {
      ...mapGetters(
        {sidebarOpened: 'sidebraOpened'})
    },
    methods: {
      handleOpen(key, keyPath) {
        console.log(key, keyPath);
      },
      handleClose(key, keyPath) {
        console.log(key, keyPath);
      },
      toStr(value){
        return value.toString();
      }
    }
  }



// WEBPACK FOOTER //
// ./src/pccomponents/aside.vue